module.exports = __webpack_public_path__ + "img/character06.97a32187.png";